// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApplyTemplateChangeEventModalQueryVariables = Types.Exact<{
  stage: Types.Stage;
}>;


export type ApplyTemplateChangeEventModalQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, displayName: string }> };

export type ApplyTemplatePlanChangeEventModalQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ApplyTemplatePlanChangeEventModalQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, applyTemplatePlanChangeEvent: Array<{ __typename?: 'ItemTemplateItemPlan', itemTemplateItem: { __typename?: 'ItemTemplateItem', id: string }, projectItem?: { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, name: string }, costTypeDetail: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } } | null | undefined }> }> };


export const ApplyTemplateChangeEventModalDocument = gql`
    query ApplyTemplateChangeEventModal($stage: Stage!) {
  itemTemplates(filter: {stage: [$stage], status: [ACTIVE]}) {
    id
    displayName
  }
}
    `;

/**
 * __useApplyTemplateChangeEventModalQuery__
 *
 * To run a query within a React component, call `useApplyTemplateChangeEventModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplateChangeEventModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyTemplateChangeEventModalQuery({
 *   variables: {
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useApplyTemplateChangeEventModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables> & ({ variables: ApplyTemplateChangeEventModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>(ApplyTemplateChangeEventModalDocument, options);
      }
export function useApplyTemplateChangeEventModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>(ApplyTemplateChangeEventModalDocument, options);
        }
// @ts-ignore
export function useApplyTemplateChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>;
export function useApplyTemplateChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplateChangeEventModalQuery | undefined, ApplyTemplateChangeEventModalQueryVariables>;
export function useApplyTemplateChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>(ApplyTemplateChangeEventModalDocument, options);
        }
export type ApplyTemplateChangeEventModalQueryHookResult = ReturnType<typeof useApplyTemplateChangeEventModalQuery>;
export type ApplyTemplateChangeEventModalLazyQueryHookResult = ReturnType<typeof useApplyTemplateChangeEventModalLazyQuery>;
export type ApplyTemplateChangeEventModalSuspenseQueryHookResult = ReturnType<typeof useApplyTemplateChangeEventModalSuspenseQuery>;
export type ApplyTemplateChangeEventModalQueryResult = Apollo.QueryResult<ApplyTemplateChangeEventModalQuery, ApplyTemplateChangeEventModalQueryVariables>;
export const ApplyTemplatePlanChangeEventModalDocument = gql`
    query ApplyTemplatePlanChangeEventModal($templateId: ID!, $changeEventId: ID!) {
  itemTemplates(filter: {id: [$templateId]}) {
    id
    applyTemplatePlanChangeEvent(changeEventId: $changeEventId) {
      itemTemplateItem {
        id
      }
      projectItem {
        ...Named
        item {
          id
          fullCode
        }
        location {
          ...Named
        }
        costTypeDetail {
          code
          name
        }
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useApplyTemplatePlanChangeEventModalQuery__
 *
 * To run a query within a React component, call `useApplyTemplatePlanChangeEventModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplatePlanChangeEventModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyTemplatePlanChangeEventModalQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useApplyTemplatePlanChangeEventModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables> & ({ variables: ApplyTemplatePlanChangeEventModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>(ApplyTemplatePlanChangeEventModalDocument, options);
      }
export function useApplyTemplatePlanChangeEventModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>(ApplyTemplatePlanChangeEventModalDocument, options);
        }
// @ts-ignore
export function useApplyTemplatePlanChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>;
export function useApplyTemplatePlanChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplatePlanChangeEventModalQuery | undefined, ApplyTemplatePlanChangeEventModalQueryVariables>;
export function useApplyTemplatePlanChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>(ApplyTemplatePlanChangeEventModalDocument, options);
        }
export type ApplyTemplatePlanChangeEventModalQueryHookResult = ReturnType<typeof useApplyTemplatePlanChangeEventModalQuery>;
export type ApplyTemplatePlanChangeEventModalLazyQueryHookResult = ReturnType<typeof useApplyTemplatePlanChangeEventModalLazyQuery>;
export type ApplyTemplatePlanChangeEventModalSuspenseQueryHookResult = ReturnType<typeof useApplyTemplatePlanChangeEventModalSuspenseQuery>;
export type ApplyTemplatePlanChangeEventModalQueryResult = Apollo.QueryResult<ApplyTemplatePlanChangeEventModalQuery, ApplyTemplatePlanChangeEventModalQueryVariables>;